import React, { useState, useEffect } from "react";
import "./contraction.css";
import contraction from "../../assets/bellypain.png";
import alarm from "../../assets/alarm.png";
import rect from "../../assets/rect.png";
import rect1 from "../../assets/rect1.png";
import relax from "../../assets/relax.png";
import contra from "../../assets/Contracting.png";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

function Contraction({ selectedTool, setSelectedTool }) {
  useEffect(() => {
    setSelectedTool("/health-issues ");
  }, []);

  const [timer, setTimer] = useState(0);
  const [mode, setMode] = useState("idle");
  const [records, setRecords] = useState([]);

  useEffect(() => {
    const savedRecords =
      JSON.parse(localStorage.getItem("contractionRecords")) || [];
    setRecords(savedRecords);
  }, []);

  useEffect(() => {
    localStorage.setItem("contractionRecords", JSON.stringify(records));
  }, [records]);

  useEffect(() => {
    let interval;
    if (mode === "contraction" || mode === "relax") {
      interval = setInterval(() => setTimer((prev) => prev + 1), 1000);
    }
    return () => clearInterval(interval);
  }, [mode]);

  const getCurrentDateTime = () => {
    return new Date().toLocaleString(); // e.g., "2/3/2025, 4:30:00 PM"
  };

  const toggleMode = () => {
    const newRecord = { mode, time: timer, date: getCurrentDateTime() };
    setRecords((prev) => [...prev, newRecord]);

    setMode(mode === "contraction" ? "relax" : "contraction");
    setTimer(0);
  };

  const startContraction = () => {
    setMode("contraction");
    setTimer(0);
  };

  const stopTimers = () => {
    if (mode !== "idle") {
      const newRecord = { mode, time: timer, date: getCurrentDateTime() };
      setRecords((prev) => [...prev, newRecord]);
    }
    setMode("idle");
    setTimer(0);
  };

  return (
    <div className="contract-base" style={{ background: "#B24C76" }}>
      <Helmet>
        <title>Contraction Timer - Track Your Contractions During Labour</title>
        <meta
          name="description"
          content="Use our contraction timer to track your contractions during labour. It's easy to use and ensures you don’t miss a moment of this special journey!"
        />
        <meta
          name="keywords"
          content="Contraction timer, contraction counter, contraction tracker"
        />
      </Helmet>
      <div className="contract-main">
        <div className="bread-container">
          <nav aria-label="breadcrumb">
            <ol className="crumb">
              <li className="breadcrumblist">
                <Link
                  to="/"
                  className="breadcrumb-link"
                  onClick={() => setSelectedTool("")}
                >
                  Home
                </Link>
              </li>
              <li className="breadcrumblist">
                <Link to="/tools" className="breadcrumb-link">
                  Tools
                </Link>
              </li>
              <li className="breadcrumblist active">Contraction </li>
            </ol>
          </nav>
        </div>
        <div className="start-main">
          <h1
            style={{
              color: "#B24C76",
              textAlign: "center",
              textTransform: "initial",
            }}
          >
            Contraction Timer
          </h1>
          <img src={contraction} className="belly-pain" alt="Belly Pain" />
        </div>
        <div className="ad-center">
          <div className="ad-left"></div>
          <div className="ad-cent">
            <p>
              Contractions are when the muscles of your uterus get tight and
              then relax. Contractions help you push your baby out of your
              uterus. Once the Contraction cycle begins, it lasts up to labor.
            </p>
            <img src={alarm} className="alrm" alt="Alarm" />
            <div className="identity">
              <div
                style={{ display: "flex", alignItems: "center", gap: "25px" }}
              >
                <img src={rect} alt="contracting" />
                <h6>Contraction Timer</h6>
              </div>
              <div
                style={{ display: "flex", alignItems: "center", gap: "25px" }}
              >
                <img src={rect1} alt="Rectangle 1" />
                <h6>Relax Duration</h6>
              </div>
            </div>
          </div>
          <div className="ad-right"></div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <p style={{ textAlign: "center", padding: "0px 50px" }}>
            Pregnancy contractions once begun will last up to labor. Sometimes
            they will continue a few days even after delivery.
          </p>

          <div style={{ textAlign: "center", padding: "20px" }}>
            {mode === "idle" && (
              <button className="cont-btn" onClick={startContraction}>
                Start Contraction Timer
              </button>
            )}
            {mode === "contraction" && (
              <div>
                <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                  Contraction Timer: {timer} seconds
                </p>
                <img
                  src={relax}
                  onClick={toggleMode}
                  alt="Toggle to Relax Timer"
                  style={{ width: "100px", cursor: "pointer" }}
                />
              </div>
            )}
            {mode === "relax" && (
              <div>
                <p style={{ fontSize: "18px", fontWeight: "bold" }}>
                  Relax Timer: {timer} seconds
                </p>
                <img
                  src={contra}
                  onClick={toggleMode}
                  alt="Toggle to Contraction Timer"
                  style={{ width: "100px", cursor: "pointer" }}
                />
              </div>
            )}
            {(mode === "contraction" || mode === "relax") && (
              <button
                className="stop-btn"
                onClick={stopTimers}
                style={{
                  margin: "30px 0px",
                  color: "white",
                  background: "#B24C76",
                  border: "none",
                  padding: "7px 18px",
                  borderRadius: "25px",
                }}
              >
                Stop Contraction Timer
              </button>
            )}
          </div>
        </div>

        {/* Records Table */}
        <div className="records-table">
          <h2 style={{ textAlign: "center", color: "#B24C76" }}>
            Contraction & Relax Times
          </h2>
          <table
            border="1"
            style={{ width: "80%", margin: "20px auto", textAlign: "center" }}
          >
            <thead>
              <tr>
                <th>Mode</th>
                <th>Time (seconds)</th>
                <th>Date & Time</th>
              </tr>
            </thead>
            <tbody>
              {records.length > 0 ? (
                records.map((record, index) => (
                  <tr key={index}>
                    <td>
                      {record.mode === "contraction" ? "Contraction" : "Relax"}
                    </td>
                    <td>{record.time}</td>
                    <td>{record.date}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3">No records yet</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Contraction;
